import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphQlClient } from '@config/graphqlClient';
import { toast } from 'react-toastify';
import { setDefaultOrganizationRequest } from '@models/user.model';
import UserGraphQL from '@graphql/user.queries';
import { USER_CURRENT_QUERY_KEY } from './useCurrentUser';
import { USER_ORGANIZATIONS_QUERY_KEY } from './useUserOrganizations';
import { useTranslation } from '@hooks/useTranslation';

export const useSetDefaultOrganization = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (organizationId: string) => {
      const response = await graphQlClient.request<setDefaultOrganizationRequest>(
        UserGraphQL.mutations.setDefaultOrganization,
        { organizationId }
      );
      return response.setDefaultOrganization;
    },
    onSuccess: async () => {
      toast.success(tActionMessages.defaultOrganizationUpdatedSuccessfully);
      // Invalidate both user and organizations queries to refresh the data
      await queryClient.invalidateQueries({ queryKey: USER_CURRENT_QUERY_KEY });
      await queryClient.invalidateQueries({ queryKey: USER_ORGANIZATIONS_QUERY_KEY });
    },
    onError: (error: any) => {
      const message = error?.response?.errors?.[0]?.message || 'Failed to update default organization';
      toast.error(message);
    },
  });
};

export default useSetDefaultOrganization;
